import { isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useDetectDevice } from './useDetectDevice';

const useVirtualKeyboard = () => {
  const { isDesktop, isAndroid } = useDetectDevice();
  const ref = useRef(null);

  const [virtualKeyboardHeight, setVirtualKeyboardHeight] = useState(0);

  const renderKeyboardFittingElement = () => {
    return (
      <KeyboardFittingElement
        style={{ height: `${virtualKeyboardHeight}px` }}
      />
    );
  };

  const handleOnShowVirtualKeyboard = (e) => {
    const inputEle = ref.current;
    const focusedElement = document.activeElement;
    if (isEmpty(inputEle)) {
      setVirtualKeyboardHeight(0);
      return;
    }
    if (isEmpty(focusedElement)) {
      setVirtualKeyboardHeight(0);
      return;
    }
    if (!focusedElement.isSameNode(inputEle)) {
      setVirtualKeyboardHeight(0);
      return;
    }
    let { x, y, width, height } = e.target.boundingRect;
    x = Math.abs(x);
    y = Math.abs(y);
    width = Math.abs(width);
    height = Math.abs(height);
    setVirtualKeyboardHeight(height);
    inputEle.scrollIntoView({
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (isDesktop) {
      console.log(`⭐ useVirtualKeyboard 👉 Running on mobile device only! ↩`);
      return;
    }
    if (isAndroid) {
      console.log(
        `⭐ useVirtualKeyboard 👉 Running on android mobile device only! ↩`
      );
      return;
    }
    const virtualKeyboardSupported = 'virtualKeyboard' in navigator;
    if (!virtualKeyboardSupported) {
      console.log(
        `⭐ useVirtualKeyboard 👉 Your device does not support the VirtualKeyboard API! ↩`
      );
      return;
    } else {
      navigator.virtualKeyboard.overlaysContent = true;
      navigator.virtualKeyboard?.addEventListener(
        'geometrychange',
        handleOnShowVirtualKeyboard
      );
    }
    return () => {
      navigator.virtualKeyboard?.removeEventListener(
        'geometrychange',
        handleOnShowVirtualKeyboard
      );
    };
  }, []);

  return { ref, KeyboardFittingElement: () => renderKeyboardFittingElement() };
};

const KeyboardFittingElement = styled.div`
  width: 100%;
  height: 0px;
`;

export default useVirtualKeyboard;
